import { render, staticRenderFns } from "./Dtr.vue?vue&type=template&id=703c911d"
import script from "./Dtr.vue?vue&type=script&lang=js"
export * from "./Dtr.vue?vue&type=script&lang=js"
import style0 from "./Dtr.vue?vue&type=style&index=0&id=703c911d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports